import React from 'react';

import MInputView from './MInput.view';

interface Props {
  innerRef?: React.RefObject<HTMLInputElement>;
  className?: string;
  inputType?: string;
  label?: string;
  name?: string;
  value?: string | number;
  defaultValue?: string;
  valid?: boolean;
  invalid?: boolean;
  errorLabel?: string;
  onBlur?: (event: React.FocusEvent) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const MInput: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MInputView
      innerRef={props.innerRef}
      type={props.inputType}
      name={props.name}
      value={props.value}
      defaultValue={props.defaultValue}
      valid={props.valid}
      invalid={props.invalid}
      errorLabel={props.errorLabel}
      onChange={props.onChange}
      className={props.className}
      label={props.label}
    >
      {props.children}
    </MInputView>
  );
};

MInput.displayName = 'MInput';
MInput.defaultProps = {};

export default MInput;
